import { TEvent } from "../../types";
import style from "./event-head.module.css";
import eventImage from "../../images/logo.png";
import AppHelper from "../../utils/helper";
import { decodeHtmlEntities } from "../../utils/html";

interface Props {
    event: TEvent;
}

const EventHead = ({ event }: Props) => {
    const isFinished = event.is_finished;
    const titleText = decodeHtmlEntities(event.title);
    const handleImageError = (e: React.SyntheticEvent<HTMLImageElement>) => {
        const target = e.target as HTMLImageElement;
        target.src = eventImage;
    };

    const shortDate = AppHelper.formatShortDate(event.date_start);

    return (
        <div className={style.image}>
            <div className={style.dateOnImage}>{shortDate}</div>
            {isFinished && <div className={style.finishedBadge}>
                <span className={style.finishBadgeText}>Завершено</span>
            </div>}
            <img
                src={event.image_urls?.middle || eventImage}
                alt={titleText}
                onError={handleImageError}
            />
        </div>
    );
}

export default EventHead;